// extracted by mini-css-extract-plugin
module.exports = {"title":"title-14Acajat","list":"list-1NjHPDXE"};